<script lang="ts">
    import {createEventDispatcher} from 'svelte';
    import {extendedAsciiTable} from './extended-ascii';
    import {specialSymbolsKeyboardStorage} from './special-symbols-keyboard-storage';

    const columns = 16;
    const rows = 13;
    const additionalChars = '$ĽłΑαΒβΓγΔδΕεΖζΗηΘθΙιΚκΛλ¹²³⁴⁵⁶⁷⁸⁹⁰₀₁₂₃₄₅₆₇₈₉ᵃᵇᶜᵈᵉᶠᵍʰⁱʲᵏˡᵐⁿᵒᵖʳˢᵗᵘᵛʷˣʸᶻₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓ';
    const symbols = [...Object.values(extendedAsciiTable).filter((str) => str), ...additionalChars]; // Similar charset as Verbis - additionally included some greek symbols
    const dispatch = createEventDispatcher<{ 'symbol': string }>();

    let lastUsedSymbols = specialSymbolsKeyboardStorage.getLastUsedSymbols();

    const handleSymbolClick = (symbol: string) => {
        specialSymbolsKeyboardStorage.saveLastUsedSymbol(symbol);
        lastUsedSymbols = specialSymbolsKeyboardStorage.getLastUsedSymbols();
        dispatch('symbol', symbol);
    }
</script>

<div class="kp-special-symbols-keyboard"
     style:--rows="{rows}"
     style:--cols="{columns}">

    <div class="special-symbols-container">
        {#each symbols as symbol, index}
            <button class="symbol-btn"
                    type="button"
                    class:bottom-bordered={index < columns * (rows - 1)}
                    class:right-bordered={(index + 1) % columns !== 0}
                    on:click={() => handleSymbolClick(symbol)}>
                {symbol}
            </button>
        {/each}
    </div>

    <div class="lastly-selected-container">
        {#each lastUsedSymbols as lastUsedSymbol}
            <button class="symbol-btn last-used-symbol"
                    type="button"
                    on:click={() => handleSymbolClick(lastUsedSymbol)}>
                {lastUsedSymbol}
            </button>
        {/each}
    </div>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "bootstrap-less/bootstrap/variables";

    @symbol-btn-size: 32px;
    @hover-highlight: #EAEEFF;

    .kp-special-symbols-keyboard {
        display: flex;
        flex-direction: column;
        width: 100%;

        .special-symbols-container {
            display: grid;
            border-bottom: 1px solid @panel-default-border;
            background-color: #F5F5F5;
            grid-template-columns: repeat(var(--cols), 1fr);
            grid-template-rows: repeat(var(--rows), @symbol-btn-size);
        }

        .lastly-selected-container {
            padding: @spacing-sm @spacing-ml;
            gap: @spacing-s;
            justify-content: center;
            display: flex;
            flex-wrap: wrap;
        }

        .symbol-btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border: none;
            background: none;
            cursor: pointer;
            outline: 2px solid transparent;
            transition: opacity 0.2s ease-in-out, background-color 0.2s ease-in-out, outline-color 0.2s ease-in-out;

            &:hover {
                opacity: 0.75;
                background-color: @hover-highlight;
                outline-color: #2D52B2;
            }

            &.bottom-bordered {
                border-bottom: 1px solid @panel-default-border;
            }

            &.right-bordered {
                border-right: 1px solid @panel-default-border;
            }

            &.last-used-symbol {
                border: 1px solid @panel-default-border;
                border-radius: @border-radius-small;
                width: @symbol-btn-size;
                height: @symbol-btn-size;
            }
        }
    }
</style>